<template>
  <FocusLock class="slo-modal-root">
    <article
      ref="root"
      class="slo-modal-frame"
      :style="{ maxWidth: maxWidth && `${maxWidth}px` }"
      @input="handleChange"
      @change="handleChange"
      v-bind="$attrs"
      v-on="$listeners"
    >
      <header>
        <h1 class="slo-modal-title">
          <slot name="title" />
        </h1>
        <button @click="maybeDismiss">
          <SloIcon name="XMark" size="lg" />
        </button>
      </header>
      <form v-if="form" action="#" @submit.prevent="$emit('formSubmit', $event)">
        <main class="slo-modal-content" v-stack-y:lg>
          <slot />
        </main>
        <footer class="slo-modal-footer">
          <slot name="footer" />
        </footer>
      </form>
      <div v-else>
        <main class="slo-modal-content" v-stack-y:lg>
          <slot />
        </main>
        <footer class="slo-modal-footer">
          <slot name="footer" />
        </footer>
      </div>
    </article>
  </FocusLock>
</template>

<script>
import FocusLock from 'vue-focus-lock';
import SloIcon from './SloIcon.vue';

export default {
  name: 'SloModal',
  components: {
    FocusLock,
    SloIcon
  },
  props: {
    form: {type: Boolean, default: true},
    router: {type: Boolean},
    maxWidth: {type: Number}
  },
  data() {
    return {
      isDirty: false
    };
  },
  mounted() {
    // disableBodyScroll(this.$refs.root)
    setTimeout(() => {
      window.addEventListener('click', this.handleClickOutside);
      window.addEventListener('keydown', this.handleEscape);
    }, 350);
  },
  beforeDestroy() {
    // enableBodyScroll(this.$refs.root)
    window.removeEventListener('click', this.handleClickOutside);
    window.removeEventListener('keydown', this.handleEscape);
  },
  methods: {
    handleEscape(event) {
      if (event.key !== 'Escape') return;
      if (
        event.target.tagName &&
        ['input', 'textarea'].includes(event.target.tagName.toLowerCase())
      )
        return;
      this.maybeDismiss();
    },
    handleClickOutside(event) {
      if (this.$refs.root?.contains(event.target)) return;
      this.maybeDismiss();
    },
    handleChange() {
      if (this.isDirty) return;
      this.isDirty = true;
    },
    maybeDismiss() {
      this.back();
    },
    back() {
      this.$emit('dismiss');
      this.$root.$emit('slo-modal:hide');
    }
  }
};
</script>

<style scoped lang="scss">
@import '../../scss/variables';
@import '../../scss/system';

.slo-modal-root {
  @include text('base');
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;

  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1090;

  &::before {
    position: absolute;
    content: '';
    background: rgba(#dedede, 0.8);
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: -1;
  }
}

.slo-modal-frame {
  display: flex;
  flex-direction: column;
  background: white;
  flex: 1;
  max-height: 80vh;
  overflow-y: auto;
  margin: auto;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1), 0 2px 4px rgba(0, 0, 0, 0.06);
  z-index: 1;

  padding: 16px;
  width: calc(100vw - 24px);
  @media screen and (min-width: $screen-sm-min) {
    width: calc(100vw - 24px);
    padding: 32px;
  }

  header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 4px;

    button {
      background: transparent;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      border-radius: 999px;
      padding: 0;
    }
  }
}

.slo-modal-content {
  display: flex;
  flex-direction: column;
  margin: 0;
  padding-top: 1em;
  background: none;
}

.slo-modal-title {
  @include text('xl');
}

.slo-modal-footer {
  display: flex;
  align-items: stretch;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 1.6rem;

  &:not(:empty) {
    margin-top: 2em;
  }

  :deep(button) {
    flex-grow: 1;
  }

  :deep(.slo-loader-icon) {
    margin-inline: auto;
    min-height: auto !important;
  }
}
</style>
